module.exports = __webpack_public_path__ + "static/media/jeshoots-com-fzOITuS1DIQ-unsplash_compr.5a0286b2.jpg";